import React, { useMemo } from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { useTolgee, useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';

type Props = {
  userName: string;
  fridgeName: string;
  openedAt: string;
};

const AlreadyConfirmedScreen: React.FC<Props> = ({
  userName,
  fridgeName,
  openedAt,
}) => {
  const { t } = useTranslate();
  const { getLanguage } = useTolgee();
  const language = getLanguage() || 'fr';

  const formattedDate = useMemo(() => {
    const date = dayjs(openedAt);

    if (!date.isValid()) return openedAt;

    return date.format('MMMM D, YYYY h:mm A'); // similar to long date + short time
  }, [openedAt]);

  return (
    <div className='ab-success-wrapper'>
      <div className='success-icon-wrapper'>
        <CheckCircleFilled style={{ fontSize: 72, color: '#4a7df5' }} />
      </div>
      <div className='success-title'>{t('Already confirmed')}</div>
      <div className='success-subtitle'>
        {userName}, {t('your visit to')} <strong>{fridgeName}</strong> {t('on')}{' '}
        <strong>{formattedDate}</strong> {t('has already been confirmed.')}
      </div>
      <div className='success-subtitle' style={{ marginTop: 12 }}>
        {t('If you need to make changes, please contact support.')}
      </div>
    </div>
  );
};

export default AlreadyConfirmedScreen;
